import apiClient from './apiClient';

export const getChatHistoryList = async () => {
    const response = await apiClient.get(`/chat/history/list`);
    return response.data;
};

export const getChatHistory = async (session_id) => {
    const response = await apiClient.get(`/chat/history`, { params: { session_id } });
    return response.data;
};


export const sendMessage = async (messageData) => {
    const response = await apiClient.post('/chat/send', messageData);
    return response.data;
};
